module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-600.woff2?819af3d3abdc9f135d49b80a91e2ff4c";